import { SET_SHIPPING_ADDRESSES, SET_DEFAULT_CARRIER_ID } from './constants'
import { ActionType, UserDetailsType } from './types'

export type StateType = {
    [key: string]: UserDetailsType
}

const INIT_STATE: StateType = {}

export default function userDetailsReducer(
    state = INIT_STATE,
    action: ActionType,
) {
    const { type, userId, shippingAddresses, defaultCarrierId } = action
    const userDetails = { ...state[userId] } || {}

    switch (type) {
        case SET_SHIPPING_ADDRESSES:
            userDetails.shippingAddresses = shippingAddresses
            return { ...state, [userId]: userDetails }
        case SET_DEFAULT_CARRIER_ID:
            userDetails.defaultCarrierId = defaultCarrierId
            return { ...state, [userId]: userDetails }
        default:
            return state
    }
}
